import React from 'react';

import { Icon } from '@shoflo-rundown/polymer.legacy';

// eslint-disable-next-line react/prop-types
const VisibilityMenuItem = ({ verb, label }) => {
  let icon;

  if (verb === 'Hide') {
    icon = 'eye-slash';
  } else if (verb === 'Show') icon = 'eye';

  return (
    <span className="grid-column-menu">
      <Icon name={icon} />
      {verb}
      <span> {label}</span>
    </span>
  );
};

export default VisibilityMenuItem;
